<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" [disabled]="disableBack" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>

            <button *ngIf="loadingEnvio" [disabled]="true" type="button" class="btn btn-outline-success">
                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                    Cargando
            </button>

            <ng-container *ngIf="mostrarBotones">
                <button *ngIf="!visibilitySpinner" [disabled]="!habilitarEnviar || (!firmado && visibilidadNoPrevia)" title="{{ tituloBoton }}" type="button" class="btn btn-outline-success" (click)="enviarSolicitud()"><i class="fa fa-envelope-o"></i> {{tituloBoton}}</button>
                <button *ngIf="visibilitySpinner" [disabled]="true" type="button" class="btn btn-outline-success">
                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                    Enviando
                </button>
    
                <button *ngIf="showSubmitWS && visibilitySubmitWS" [disabled]="deshabilitarSubmit" title="Reenviar Traces/Aduanas" type="button" class="btn btn-outline-success" (click)="submitOnDemand()"><i class="fa fa-paper-plane"></i> Reenviar</button>
    
    
                
    
                <button *ngIf="!visibilitySpinnerV3 && showAduanasWS" [disabled]="habilitarEnviar" type="button" title="V3" class="btn btn-outline-success" (click)="sendV3OnDemand()"><i class="fa fa-rocket"></i> V3</button>
                <button *ngIf="visibilitySpinnerV3" [disabled]="true" type="button" class="btn btn-outline-success">
                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                    V3 Sending
                </button>
    
                <button *ngIf="!visibilitySpinnerV3Reset && showAduanasWS" [disabled]="habilitarEnviar" type="button" title="V3 Reset" class="btn btn-outline-success" (click)="resetV3OnDemand()"><i class="fa fa-reply"></i> V3 Reset</button>
                <button *ngIf="visibilitySpinnerV3Reset" [disabled]="true" type="button" class="btn btn-outline-success">
                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                    V3 Resetting
                </button>
    
                <button *ngIf="!visibilitySpinnerTNT && showTracesWS" [disabled]="habilitarEnviar" type="button" title="TNT Init" class="btn btn-outline-success" (click)="sendTracesOnDemand()"><i class="fa fa-bomb"></i> TNT Init</button>
                <button *ngIf="visibilitySpinnerTNT" [disabled]="true" type="button" class="btn btn-outline-success">
                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                    TNT Sending
                </button>
    
                <button *ngIf="!visibilitySpinnerTNTReset && showTracesWS" [disabled]="habilitarEnviar" type="button" title="TNT Reset" class="btn btn-outline-success" (click)="resetTracesOnDemand()"><i class="fa fa-reply"></i> TNT Reset</button>
                <button *ngIf="visibilitySpinnerTNTReset" [disabled]="true" type="button" class="btn btn-outline-success">
                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                    TNT Resetting
                </button>
            </ng-container>
        </div>
    </nav>


    <div class="animated fadeIn container-fluid">
        <div>
            <h5 *ngIf="codigoSolicitud !== null" style="display:inline">Código de Solicitud: {{codigoSolicitud}}</h5>
            <h5 *ngIf="codigoSolicitud !== null" style="display:inline; margin-left: 8px">
                <span>
                    <!--***ICONOS***-->
                    <img class="estado-icono-big" container="body" src="{{IdTipoSolicitud | IconoTipoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                    <img class="estado-icono-big" container="body" src="{{solicitud.IdEstadoSolicitud | IconoEstadoSolicitud}}" ngbTooltip="{{tituloEstadoSolicitud}}" />
                    <img *ngIf="solicitud.IdEstadoChedPp" class="estado-icono-big" container="body" src="{{solicitud.IdEstadoChedPp | IconoEstadoChedPP}}" ngbTooltip="{{solicitud.IdEstadoChedPpDescripcion}}" />
                    <img *ngIf="solicitud.IdResultadoEnvioMuestrasLaboratorio" class="estado-icono-big" container="body" src="{{solicitud.IdResultadoEnvioMuestrasLaboratorio | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitud.DescripcionIdResultadoEnvioMuestrasLaboratorio}}" />
                    <img class="predua-icono-big" container="body" ngbTooltip="{{esPredua | preduaNoPredua}}" src="{{esPredua | IconoPreduaSolicitud}}" />
                    <img *ngIf="esClonada" container="body" class="estado-icono-big" src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="Clonada" />
                    <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
                </span>
            </h5>
            <h5 *ngIf="codigoSolicitud === null" style="display:inline">Solicitud </h5>
            <h5 *ngIf="codigoSolicitud === null" style="display:inline; margin-left: 8px">
                <span>
                    <!--***ICONOS***-->
                    <img class="estado-icono-big" container="body" src="{{IdTipoSolicitud | IconoTipoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                    <img class="estado-icono-big" container="body" src="{{solicitud.IdEstadoSolicitud | IconoEstadoSolicitud}}" ngbTooltip="{{tituloEstadoSolicitud}}" />
                    <img *ngIf="solicitud.IdEstadoChedPp" class="estado-icono-big" container="body" src="{{solicitud.IdEstadoChedPp | IconoEstadoChedPP}}" ngbTooltip="{{solicitud.IdEstadoChedPpDescripcion}}" />
                    <img *ngIf="solicitud.IdResultadoEnvioMuestrasLaboratorio" class="estado-icono-big" container="body" src="{{solicitud.IdResultadoEnvioMuestrasLaboratorio | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitud.DescripcionIdResultadoEnvioMuestrasLaboratorio}}" />
                    <img class="predua-icono-big" container="body" ngbTooltip="{{esPredua | preduaNoPredua}}" src="{{esPredua | IconoPreduaSolicitud}}" />
                    <img *ngIf="esClonada" container="body" class="estado-icono-big" src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="Clonada" />
                    <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
                </span>
            </h5>
        </div>

        <div *ngIf="fechaSolicitud !== null">
            <h5>Fecha de Envío: {{fechaSolicitud}}</h5>
        </div>

        <div *ngIf="codigoTraces !== null">
            <h5>Código de TRACES: {{codigoTraces}}</h5>
        </div>
        <div *ngIf="identificadorNoProcede !== null">
            <h5>Código: {{identificadorNoProcede}}</h5>
        </div>

        <div *ngIf="visibilitySpinner" class="nota-info warning mb-2">
            <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Por favor, no salga de la ventana actual, hay una operación en curso.</label>
        </div>

        <!--ICONO CHECK LISTA PARA ENVIO-->
        <div style="margin-top: 10px;">
            <h5 style="display:inline">
                <span>
                    <img class="check-envio" src="{{ visibilityCheckEnvioValue | IconoCheckEnvio}}" />
                </span>
            </h5>
            <h5 style="display:inline">{{mensajeEmision}}</h5>
        </div>

        <div class="row">
            <div class="col-md-12">
                <!--Validaciones propias de la solicitud-->
                <table *ngIf="validacionCollection !== null && validacionCollection?.length > 0" class="table table-responsive table-sm">
                    <tbody>
                        <tr *ngFor="let item of validacionCollection">
                            <td class="empty-grid">{{item}}</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>

        <!--Errores validacion TRACES-->
        <div *ngIf="visibilityErroresTraces && (solicitud.FechaEnvio === null || esRevisionSolicitante)" class="row" pt-8>
            <!--lista de errores de TRACES-->
            <div class="row  traces-errors-list">
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">

                        <a class="card-header-a bg-warning" (click)="isCollapsedGrid = !isCollapsedGrid" [attr.aria-expanded]="!isCollapsedGrid" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-list"></i> Listado de Errores de Validación de TRACES
                                <i *ngIf="isCollapsedGrid" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedGrid" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="collapse group-filtros" id="collapsedGrid" [ngbCollapse]="isCollapsedGrid">
                            <div class="card-body-detalle">
                                <div class="row">
                                    <table class="table table-responsive table-sm">
                                        <thead class="col-md-12">
                                            <tr>
                                                <th>Código</th>
                                                <th>Mensaje</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of erroresEnvioTraces">
                                                <td>{{item.Code}}</td>
                                                <td>{{item.Message}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!--Errores validacion Aduanaas V3-->
        <div *ngIf="visibilityErroresAduanas" class="row">
            <div class="col-md-12">

                <table class="table table-responsive table-sm">
                    <thead class="col-md-12">
                        <tr>
                            <th>Código</th>
                            <th>Descripcion</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="empty-grid">{{errorEnvioAduanas.Code}}</td>
                            <td class="empty-grid">{{errorEnvioAduanas.Message}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!--TABLA Listado Números Autorización (solo se carga con Canarias y PIF Canario)-->
        <div *ngIf="showNRC && listNumAutorizacion !== null && listNumAutorizacion?.length > 0" class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedGrid = !isCollapsedGrid" [attr.aria-expanded]="!isCollapsedGrid" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-list"></i> Listado de Números de Autorización
                            <i *ngIf="isCollapsedGrid" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedGrid" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="collapse group-filtros" id="collapsedGrid" [ngbCollapse]="isCollapsedGrid">
                        <div class="card-body-detalle-list">
                            <div class="row">
                                <div class="col-md-12">
                                    <table class="table table-list table-responsive table-sm">
                                        <thead>
                                            <tr>
                                                <th class="cabecerasTablaDetalles col-md-2">NRC</th>
                                                <th class="cabecerasTablaDetalles col-md-2">Estado Envío Aduanas</th>
                                                <th class="cabecerasTablaDetalles col-md-1">Código Taric</th>
                                                <th class="cabecerasTablaDetalles col-md-1">Partida</th>
                                                <th class="cabecerasTablaDetalles col-md-3">Respuesta</th>
                                                <th class="cabecerasTablaDetalles col-md-3">Error</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of listNumAutorizacion">
                                                <td scope="col" class="col-md-2">{{item.Nrc}}</td>
                                                <td scope="col" class="col-md-2">{{item.EstadoEnvioAduanas}}</td>
                                                <td scope="col" class="col-md-1">{{item.CodigoTaric}}</td>
                                                <td scope="col" class="col-md-1">{{item.Partida}}</td>
                                                <td scope="col" class="col-md-3">{{item.Respuesta}}</td>
                                                <td scope="col" class="col-md-3">{{item.Error}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <ng-container *ngIf="IdSolicitud">
            <app-alerta-chedd [solicitud]="solicitud"></app-alerta-chedd>
            <app-alertarechazo [id]="IdSolicitud" [esImport]="true"></app-alertarechazo>
        </ng-container>

        <!--VISIBLE PARA INSPECTOR-->
        <!--REENVIO TRACES-->
        <div *ngIf="visibilidadReenvioTraces" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedReenvioTraces = !isCollapsedReenvioTraces" [attr.aria-expanded]="!isCollapsedReenvioTraces" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Reenvío a TRACES
                            <i *ngIf="isCollapsedReenvioTraces" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedReenvioTraces" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros" id="collapsedReenvioTraces" [ngbCollapse]="isCollapsedReenvioTraces">
                            <div style="padding-top:7px;" class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="inpFecha">Estado: </label>
                                            <input formControlName="IdEstadoDescripcion" name="Estado" readonly title="" class="form-control" id="inpDescripcion" type="text" value="">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="inpFecha">Código: </label>
                                            <input formControlName="Codigo" name="Codigo" readonly title="" class="form-control" id="inpDescripcion" type="text" value="">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="inpFecha">Fecha: </label>
                                            <input formControlName="Fecha" name="Fecha" readonly title="" class="form-control" id="inpDescripcion" value="">
                                        </div>
                                    </div>
                                </div>
                                <!--@adua:27/01/2021 nuevos ws-->
                                <!--<div class="col-md-6">
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="">Pulse para el reenvío:</label>
                                        <button name="btnReenvioTraces" class="btn btn-list btn-secondary" type="button" title="Reenviar a TRACES" (click)="reenviarTraces()"><i class="fa fa-envelope-open-o"></i> Reenviar TRACES </button>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="">Pulse para el reenvío:</label>
                                        <button name="btnIgnorarTraces" class="btn btn-list btn-secondary" type="button" title="Ignorar TRACES" (click)="ignorarTraces()"><i class="fa fa-share-square-o"></i> Ignorar TRACES </button>
                                    </div>
                                </div>
                            </div>-->
                            </div>

                            <!--lista de errores de TRACES-->
                            <div style="padding-top:7px;" class="row">

                                <div class="card card-accent-success animated fadeIn">
                                    <div class="col-md-12">
                                        <a class="card-header-a" (click)="isCollapsedGrid = !isCollapsedGrid" [attr.aria-expanded]="!isCollapsedGrid" aria-controls="collapseExample">
                                            <div class="card-header-buscador">
                                                <i class="fa fa-list"></i> Listado de Errores de Envío a TRACES
                                                <i *ngIf="isCollapsedGrid" class="fa fa-caret-down float-right"></i>
                                                <i *ngIf="!isCollapsedGrid" class="fa fa-caret-up float-right"></i>
                                            </div>
                                        </a>

                                        <div class="collapse group-filtros" id="collapsedGrid" [ngbCollapse]="isCollapsedGrid">
                                            <div class="card-body-detalle">
                                                <div class="row">
                                                    <table class="table table-responsive table-sm">
                                                        <thead class="col-md-12">
                                                            <tr>
                                                                <th>Código</th>
                                                                <th>Mensaje</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let item of erroresEnvioTraces">
                                                                <td>{{item.Code}}</td>
                                                                <td>{{item.Message}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <fieldset *ngIf="visibilidadNoPrevia" class="mt-2 card">
            <div class="row">
                <div class="form-group col-md-12">
                    <label class="col-form-label" for="inpFecha"> El abajo firmante, operador responsable de la partida descrita anteriormente, certifica que, a su leal saber y entender, los datos que figuran en esta solicitud están completos y son ciertos, y se compromete a cumplir los requisitos del Reglamento (UE) 2017/625 sobre los controles oficiales, incluido el pago de los controles oficiales, así como de la reexpedición de partidas, la puesta en cuarentena o el aislamiento de los animales, o los costes de su eutanasia y eliminación, si fuera necesario. </label>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-2">
                    <label class="col-form-label required-field">Firmado </label>
                    <p-toggleButton class="form-control-togglebutton"
                                    formControlName="Firmado" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times" (onChange)="onSelectedFirmado()" id=""></p-toggleButton>
                </div>
                <div class="form-group col-md-2">
                    <label class="col-form-label" for="inpFecha">Fecha de la firma</label>
                    <input readonly formControlName="FechaEnvio" name="FechaEnvio" title="" class="form-control" id="inpDescripcion" value="">
                </div>
                <div class="form-group col-md-4">
                    <label class="col-form-label" for="inpCodigo">Solicitante</label>
                    <input readonly formControlName="Solicitante" name="Solicitante" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                </div>
                <div class="form-group col-md-4">
                    <label class="col-form-label" for="inpCodigo">{{labelEmailOtlf}}</label>
                    <input readonly formControlName="EmailOtlf" name="EmailOtlf" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                </div>
            </div>
            <div *ngIf="esCanariasCf" class="row">
                <div class="form-group col-md-2">
                    <label class="col-form-label" for="inpCodigo">Viene de CF:</label>
                    <input readonly formControlName="Certificado" name="Certificado" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                </div>
            </div>
        </fieldset>

    </div>

</form>
